import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"com-mb-card"},[_c(VCol,{staticClass:"com-mb-card-contents pa-0"},[_c(VCol,{staticClass:"px-2"},[_c('span',{staticClass:"gray--text text--darken-1"},[_vm._v(_vm._s(_vm.text.title))])]),_c(VImg,{attrs:{"src":"/kawabou/img/hanrei_hazard_object.png"}},[_c(VImg,{attrs:{"src":"/kawabou/img/hanrei_hazard_base.png","id":"hazard_base"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }